import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Box,
  DashPlaceholder,
  Flex,
  Text,
  Button,
  A,
  Image,
  mainTheme,
} from 'dash-ui';
import { formatAddress } from 'dash-common';

import { GetOrganizationByIdQuery } from 'gql/generated.graphql';

import SaveOrganizationModal from 'pages/OrganizationPage/OrganizationDetailsPage/components/SaveOrganizationDetailsModal/SaveOrganizationDetailsModal';
import PermissionCheck from 'flow-components/PermissionCheck/PermissionCheck';
import { FlexWraper, SubFlexWraper } from 'pages/OrganizationPage/OrganizationDetailsPage/components/OrganizationDetailsHeader/OrganizationDetailsHeader.style';

interface IProps {
  organization: GetOrganizationByIdQuery['getOrganizationById'];
}

function OrganizationDetailsHeader({ organization }: IProps) {
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const { t: tOrganizationPage } = useTranslation('pages', {
    keyPrefix: 'organisationPage',
  });
  const { website, location, name, logoFile } = organization;

  return (
    <Box px={6} py={4} w="100%">
      <FlexWraper alignItems="center">
        {logoFile ? (
          <Image src={logoFile?.publicUrl} size={92} fit="contain" />
        ) : (
          <DashPlaceholder size={92} />
        )}

        <SubFlexWraper
          flexDirection="row"
          justifyContent="space-between"
          flex={1}
          w="100%"
        >
          <Flex flexDirection="column" justifyContent="space-between">
            <Text xl bold>
              {name}
            </Text>
            {location ? (
              <Text color={mainTheme.colors.n80}>
                {formatAddress(location.address)}
              </Text>
            ) : (
              <Text
                color={mainTheme.colors.n80}
              >{tOrganizationPage`addressUnavailable`}</Text>
            )}
            {website ? (
              <A href={website} target="_blank">
                {website}
              </A>
            ) : (
              <Text
                color={mainTheme.colors.n80}
              >{tOrganizationPage`websiteUnavailable`}</Text>
            )}
          </Flex>
        </SubFlexWraper>

        <PermissionCheck>
          <Button
            variation="outline"
            round
            icon="edit"
            onClick={() => setIsEditModalOpen(true)}
          />
        </PermissionCheck>
      </FlexWraper>

      <SaveOrganizationModal
        organization={organization}
        isOpen={isEditModalOpen}
        onClose={() => setIsEditModalOpen(false)}
      />
    </Box>
  );
}

export default OrganizationDetailsHeader;
